import { Pagination } from "antd";
import moment from "moment";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Table } from "reactstrap";
import useRowSelection from "../../views/Admin/customHooks/useRowSelection";

const PurchaseOrderList = ({ purchaseOrdersbyVendor }) => {
  const { user } = useSelector((state) => state.auth);
  const history = useHistory();
  const { itemsPerPage, endIndex, startIndex, currentPage, setCurrentPage } =
    useRowSelection();

  const hasData = purchaseOrdersbyVendor && purchaseOrdersbyVendor.length > 0;

  return (
    <div className="modern-table-container mt-2">
      {hasData ? (
        <>
          <Table
            responsive
            hover
            className="modern-table modern-table-sm mb-0"
          >
            <thead>
              <tr>
                <th>PO Number</th>
                <th>Total</th>
                <th>Items</th>
                {/* <th>Buyer</th> */}
                <th>Date</th>
                <th>Status</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {purchaseOrdersbyVendor
                ?.slice(startIndex, endIndex)
                ?.map((i, index) => (
                  <tr key={i?._id}>
                    <td className="fw-bold">{i?.po_no}</td>
                    <td className="fw-bold">
                      ${i?.total ? parseFloat(i?.total)?.toFixed(2) : 0}
                    </td>
                    <td>{i?.line_items?.length ?? 0}</td>
                    {/* <td className="text-muted">{user?.username ?? ""}</td> */}
                    <td className="text-muted">{moment(i?.created_at).format("L")}</td>
                    <td>
                      <span className={`user-badge ${i?.purchaseOrderStatus === "cancel" ? "bg-danger-soft" : "bg-success-soft"
                        }`}>
                        {i?.purchaseOrderStatus === "cancel" ? "Cancelled" : "Active"}
                      </span>
                    </td>
                    <td className="text-center">
                      <button
                        className="btn-action bg-primary-soft text-primary p-1 px-3 fs-13"
                        style={{ border: "none", borderRadius: "6px", fontWeight: "500" }}
                        onClick={() => {
                          history.push({
                            pathname: `/admin/update-purchase-orders-details/${i?._id}`,
                            state: {
                              obj: i,
                              vendor: {
                                billing: [i?.vendor],
                                id: i?.vendorOrderId,
                                _id: i?.vendorId,
                              },
                            },
                          });
                        }}
                      >
                        Details
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>

          <div className="d-flex justify-content-end p-3 border-top bg-white">
            <Pagination
              size="small"
              current={currentPage}
              total={purchaseOrdersbyVendor?.length}
              pageSize={itemsPerPage}
              showSizeChanger={false}
              onChange={(val) => {
                setCurrentPage(val);
              }}
            />
          </div>
        </>
      ) : (
        <div className="text-center py-5 text-muted fs-14 bg-white rounded-12">
          No purchase orders found for this vendor.
        </div>
      )}
    </div>
  );
};

export default PurchaseOrderList;
